import React from "react";
import { Helmet } from "react-helmet";

const SEO = () => {
  return (
    <Helmet>
      {/* Open Graph Metadata */}
      <meta property="og:title" content="Commceed | Innovation in Motion, Solutions in Action" />
      <meta
        property="og:description"
        content="At commceed, we deliver forward-thinking solutions that power your network, elevate your infrastructure, and keep you ahead of the curve. We transform ideas into reality with precision and expertise."
      />
      <meta property="og:url" content="https://commceed.com" />
      <meta property="og:type" content="website" />
      <meta property="og:image" content="https://commceed.com/logo512.png" />

      {/* Twitter Metadata */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Commceed | Innovation in Motion, Solutions in Action" />
      <meta
        name="twitter:description"
        content="At commceed, we don't just deliver products; we provide forward-thinking solutions that transform your business and keep you ahead of the curve."
      />
      <meta name="twitter:image" content="https://commceed.com/logo512.png" />

      {/* Structured Data for Organization */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "commceed",
          "url": "https://commceed.com",
          "logo": "https://commceed.com/logo512.png",
          "description":
            "At commceed, we provide global supply chain solutions, transforming ideas into innovative products that power networks and elevate infrastructures across the globe.",
        })}
      </script>
    </Helmet>
  );
};

export default SEO;
